import script from "./ServiceTopSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceTopSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ServiceTopSkeleton.vue?vue&type=style&index=0&id=4018940b&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4018940b"]])

export default __exports__